module.exports = __webpack_public_path__ + "static/f65f88e6.eng_banner.png";